.id {
  &.inline {
    display: inline-flex;
  }
}
